
/**
 * <merchandise-group-nav> custom element
 *
 * Wraps the merchandise group tile grid. Tiles navigate normally via their
 * href — no AJAX interception. The custom element is kept so the tag remains
 * defined and CSS/attribute selectors continue to work after section re-renders.
 */
class MerchandiseGroupNav extends HTMLElement {
    // No click interception — browser handles <a> tiles as plain links.
}

if (!customElements.get('merchandise-group-nav')) {
    customElements.define('merchandise-group-nav', MerchandiseGroupNav);
}